module.exports = __webpack_public_path__ + "img/6.5e037d17.png";